import { Box, Breadcrumb, Breadcrumbs, Divider } from "@carrotfertility/carotene-core"
import React from "react"
import { FormattedMessage } from "react-intl"
import { Link } from "react-router-dom"

export type BookingEntrySource = "careTeam" | "searchResults" | "carrotPlan"

type BookingBreadcrumbState = {
  entrySource: BookingEntrySource
  stage: "coverage" | "booking"
  onReturn?: () => void
}

const BookingBreadcrumbContext = React.createContext<BookingBreadcrumbState>({
  entrySource: "carrotPlan",
  stage: "booking"
})

export function BookingBreadcrumbProvider({
  children,
  ...overrides
}: Partial<BookingBreadcrumbState> & { children: React.ReactNode }): JSX.Element {
  const inherited = React.useContext(BookingBreadcrumbContext)
  return (
    <BookingBreadcrumbContext.Provider value={{ ...inherited, ...overrides }}>
      {children}
    </BookingBreadcrumbContext.Provider>
  )
}

export function BookingBreadcrumbs(): JSX.Element {
  const { entrySource, stage, onReturn } = React.useContext(BookingBreadcrumbContext)
  const returnLabel = {
    careTeam: <FormattedMessage defaultMessage="Get Clinical Care" />,
    searchResults: <FormattedMessage defaultMessage="Search results" />,
    carrotPlan: <FormattedMessage defaultMessage="Your Carrot Plan" />
  }[entrySource]
  return (
    <Box sx={(theme) => ({ display: "flex", flexDirection: "column", gap: theme.spacing(theme.tokens.spacing.sm) })}>
      <Breadcrumbs>
        {onReturn ? (
          <Breadcrumb component="button" type="button" onClick={onReturn}>
            {returnLabel}
          </Breadcrumb>
        ) : (
          <Breadcrumb component={Link} to={entrySource === "careTeam" ? "/care-team" : "/"}>
            {returnLabel}
          </Breadcrumb>
        )}
        <Breadcrumb currentPage>
          {stage === "coverage" ? (
            <FormattedMessage defaultMessage="Coverage" />
          ) : (
            <FormattedMessage defaultMessage="Book now" />
          )}
        </Breadcrumb>
      </Breadcrumbs>
      <Divider />
    </Box>
  )
}
